import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Manifest } from 'services/action';

import { ActionDate } from './utils'

export const ActionArrived = ({ manifest, legs, onSubmit, handleClose, loading = false }) => {
    const Dispatch = useDispatch();
    const StateForm = useSelector((state) => state?.Form);

    const $handleSubmit = async (val) => {
        const payload = {
            ata_at: val?.time,
            latitude: legs?.location?.latitude,
            longitude: legs?.location?.longitude,
        };

        const req = await Dispatch(Manifest.$arrive(manifest?.id, legs?.id, payload));
        if (req?.message === 'success') {
            if (onSubmit) onSubmit();
            if (handleClose) handleClose();
        }
    }

    return (
        <>
            <ActionDate
                dateLabel="Tanggal Kedatangan"
                timeLabel="Jam Kedatangan"
                disabled={false}
                isLoading={loading}
                onSubmit={$handleSubmit}
                errors={StateForm?.errors?.ata_at || StateForm?.errors?.id}
                handleClose={handleClose}
            />
        </>
    )
}
